import { ApexOptions } from "apexcharts";
import React from "react";
import ReactApexChart from "react-apexcharts";
import { ChartState, YAxisConfig } from "../../pages/Dashboard/Home.tsx";

interface ChartOneProps {
  chartData: ChartState | null;
  loading: boolean;
  xAxisCategories: string[];
  yAxisConfig?: YAxisConfig | null;
}

const PremiumsChart: React.FC<ChartOneProps> = ({
  chartData,
  loading,
  xAxisCategories,
  yAxisConfig,
}) => {
  const options: ApexOptions = {
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "right",
      labels: {
        colors: "currentColor",
      },
      fontFamily: "Satoshi, sans-serif",
      fontSize: "12",
    },
    colors: ["var(--color-secondary)", "#64748B"],
    chart: {
      fontFamily: "Satoshi, sans-serif",
      height: 335,
      type: "area",
      dropShadow: {
        enabled: true,
        color: "#000000",
        top: 10,
        blur: 8,
        left: 0,
        opacity: 0.08,
      },
      toolbar: { show: false },
      sparkline: { enabled: false },
      zoom: { enabled: false },
    },
    stroke: {
      width: [2.5, 2.5],
      curve: "smooth",
      lineCap: "round",
    },
    grid: {
      borderColor: "#E2E8F0",
      padding: { top: 15, right: 10, bottom: 0, left: 0 },
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },
    dataLabels: { enabled: false },
    markers: {
      size: 5,
      colors: ["#ffffff"],
      strokeColors: ["var(--color-secondary)", "#64748B"],
      strokeWidth: 2.5,
      hover: { sizeOffset: 6 },
      shape: "circle",
    },
    xaxis: {
      type: "category",
      categories: xAxisCategories || chartData?.categories || [],
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        style: {
          colors: "#64748B",
          fontSize: "12px",
          fontFamily: "Satoshi, sans-serif",
          fontWeight: 500,
        },
      },
    },
    yaxis: {
      title: {
        style: {
          fontSize: "13px",
          fontWeight: 600,
          color: "#64748B",
          fontFamily: "Satoshi, sans-serif",
        },
      },
      min: 0,
      max: yAxisConfig?.max ?? 1400000,
      tickAmount: yAxisConfig?.tickAmount ?? 10,
      labels: {
        style: {
          colors: "#64748B",
          fontSize: "12px",
          fontFamily: "Satoshi, sans-serif",
        },
        formatter: (val) => {
          if (val >= 1000000) return (val / 1000000).toFixed(1) + "M";
          if (val >= 1000) return (val / 1000).toFixed(0) + "K";
          return val.toLocaleString();
        },
      },
    },
    tooltip: {
      theme: "light",
      style: { fontSize: "12px", fontFamily: "Satoshi, sans-serif" },
      x: { show: true },
      y: { formatter: (val) => val.toLocaleString() + " BGN" },
      marker: { show: true },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100],
      },
    },
  };

  return (
    <div className="border-stroke shadow-default dark:border-strokedark dark:bg-boxdark col-span-12 rounded-sm border bg-white xl:col-span-12">
      <div className="border-stroke dark:border-strokedark flex justify-between border-b px-6 py-5">
        <div>
          <h2 className="text-title-md2 mb-1.5 font-bold text-black dark:text-white">
            Премии
          </h2>
          <p className="text-bodydark1 text-sm font-medium dark:text-slate-400">
            Исторически данни за последните 12 месеца
          </p>
        </div>
      </div>

      <div className="pt-7.5 sm:px-7.5 px-5 pb-5">
        {loading ? (
          <div className="flex h-[335px] items-center justify-center">
            <div className="border-secondary h-12 w-12 animate-spin rounded-full border-4 border-solid border-t-transparent" />
          </div>
        ) : chartData && chartData.series.length > 0 ? (
          <ReactApexChart
            options={options}
            series={chartData.series}
            type="area"
            height={335}
          />
        ) : (
          <div className="flex h-[335px] items-center justify-center">
            <span className="text-bodydark1 dark:text-slate-400">
              Няма налични данни
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PremiumsChart;
